<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('metodi_pagamento_title')}}</h1></div>
            <div class="content content-full">
                <form>
                    <div class="title">{{$t('gestisci_carte_salvate')}}</div>
                    <div class="container">
                        <div class="row-sezione">
                            <button
                                type="button"
                                class="btn btn-block"
                                :disabled="!canAddCreditCard"
                                @click="onAddCardPress"
                            >
                              <div class="d-flex justify-content-between align-items-center" >
                                <div class="d-flex align-items-center">
                                  <span class="material-symbols-outlined">
                                  credit_card
                                  </span><div class="pl-2" style="font-weight:500"> {{$t('aggiungi_carta_title')}}</div>
                                </div>
                                <i class="pi pi-plus"></i>
                              </div>
                            </button>


                            <div class="blocchetto p-0 d-flex align-items-center justify-content-between"
                                 v-if="methods"
                                 v-for="method in methods">
                                <div class="flex-grow-1">
                                    <div style="padding: 4px 6px;"><b class="text-capitalize">{{method.data.brand}} ****
                                        {{method.data.last4}}</b><br>
                                    {{$t('scad')}}
                                    {{method.data.expMonth.toString().padStart(2, '0')}}/{{method.data.expYear}}
                                    </div>
                                </div>
                              <div class="d-flex flex-column align-items-stretch">
                                <a href="#" class="a1" @click.prevent="onDeletePress(method)">
                                  <div class="d-flex align-items-center align-items-stretch bg-button-delete my-0" style="padding: 6px; border-radius: 0 5px 5px 0;">
                                  <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('elimina')">
                                        delete
                                        </span>
                                  </div>
                                </a>
                              </div>
                            </div>


                        </div>
                    </div>

                    <div class="container d-none d-md-block">
                      <hr>
                        <div class="row-sezione d-flex justify-content-center">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <modal-confirm :header-title="$t('attenzione_label')"
                       :body-text="$t('confirm_remove_metodo_pagamento')"
                       v-if="this.show_confirm_modal"
                       @close="onConfirm"
        />
        <modal-stripe-payment v-if="this.show_stripe_payment_modal"
                              :stripe="this.stripe"
                              :save="true"
                              :hide-save-card="true"
                              @close="show_stripe_payment_modal = false"
                              @onSubmit="onSubmitCreditCard"
        />
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

import {
    stripeDetachPaymentMethod,
    stripeGetPaymentMethods,
    stripeGetSetupIntentClientSecret
} from "../../api/account";
import {getMixedInfo} from "../../api/restaurant";

import ModalConfirm from "../partials/ModalConfirm";
import ModalStripePayment from "../partials/ModalStripePayment";

export default {
    name: "Payments",
    components: {ModalStripePayment, ModalConfirm},
    data() {
        return {
            stripe: null,
            methods: null,
            canAddCreditCard: false,

            show_stripe_payment_modal: false,
            show_confirm_modal: false,
            selected_method: null
        }
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    created() {
        this.fetch();
    },
    watch: {
        language: function () {
            this.fetch();
        },
        locale: function (newLocale, oldLocale) {
            if (newLocale && (!oldLocale || newLocale.id !== oldLocale.id)) {
                this.fetch();
            }
        }
    },
    methods: {
        fetch: async function () {
            this.showLoading(true);
            try {
                this.stripe = null;
                this.canAddCreditCard = false;

                const stripePaymentMethods = (
                    await stripeGetPaymentMethods(this.language, {
                        id_ristorante: this.id_ristorante,
                        api_key: this.user.api_key,
                    })
                ).methods;

                // Modalità di pagamento
                const modalitaPagamentoStripe = (
                    await getMixedInfo(this.language, {
                        id_ristorante: this.id_ristorante,
                        id_locale: this.locale.id,
                        modalita_pagamento: true,
                        credenziali_pagamento: true,
                    })
                ).modalita_pagamento.find((obj) => obj.tipo === 'STRIPE_CARTACREDITO');

                if (modalitaPagamentoStripe) {
                    this.stripe = Stripe(modalitaPagamentoStripe.credenziali.publishable_key, {locale: this.language});
                    this.canAddCreditCard = true;
                }

                this.methods = stripePaymentMethods;
            } catch ({messages}) {
                alert(messages.join('\n'));
            } finally {
                this.showLoading(false);
            }
        },
        onConfirm: async function (success) {
            this.show_confirm_modal = false;

            if (success) {
                try {
                    await stripeDetachPaymentMethod(this.language, {
                            id_ristorante: this.id_ristorante,
                            api_key: this.user.api_key,
                            id: this.selected_method.id,
                            id_locale: this.selected_method.locali[0].id,
                        },
                    );

                    await this.fetch();
                } catch ({messages}) {
                    alert(messages.join('\n'));
                }

            }
            this.selected_method = null;
        },
        onDeletePress: function (method) {
            this.selected_method = method;
            this.show_confirm_modal = true
        },
        onAddCardPress: function () {
            if (!this.canAddCreditCard) {
                return;
            }

            this.show_stripe_payment_modal = true;
        },
        onSubmitCreditCard: async function (card) {
            this.showLoading(true);
            try {
                const clientSecret = (
                    await stripeGetSetupIntentClientSecret(this.language, {
                            id_ristorante: this.id_ristorante,
                            id_locale: this.locale.id,
                            api_key: this.user.api_key,
                        },
                    )
                ).client_secret;

                await this.stripe.confirmCardSetup(clientSecret, {
                    payment_method: {
                        card: card
                    }
                });

                this.show_stripe_payment_modal = false;

                await this.fetch();
            } catch ({messages}) {
                alert(messages.join('\n'));
            } finally {
                this.showLoading(false);
            }
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
